import React, { useEffect, useState }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableLayout } from '../../containers/Layout';
import { TableRow, TableHead, TableCell, TableBody, Typography, IconButton } from '@material-ui/core';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import Currency from '../../../../../commonModules/Currency';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { isEmpty } from 'lodash-es';
import { CollectionsBookmark } from '@material-ui/icons';
import PopUp from '../../../../../commonModules/interface/PopUp';
import PreviewLoc from '../../localisations/PreviewLoc';

const SingleTransferPurchase = (props) => {
    const dispatch = useDispatch();
    const [purchase, setPurchase] = useState({});
    const [shop, setShop] = useState({});
    const [local, setLocal] = useState({});
    const [openLocal, setOpenLocal] =  useState(false);
    const [productName, setProductName] =  useState("");
    const [pItem, setPItem] =  useState({});
    const [src, setSrc] = useState("");
    const [newfiles, setNewFiles] = useState([]);
    const [addFiles, setAddFiles] = useState(false);
    const PRODUCTS = useSelector((state) => state.inventory.products); 
	const STATE_PURCHASE = useSelector((state) => state.inventory.requestState.purchases); 
    // const addFilesPurchase = dispatch( addFilesPurchase());

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const purchaseData = await dispatch(fetchTransferDetails(props.purchase.id));
                setPurchase(purchaseData);
            } catch (error) {
                console.error('Error fetching purchase details:', error);
            }
        };
        const fetchLocal = async () => {
            try {
                const req = await fetch("/stocks/locals/shop",{
                    method:"POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ shopID: props.purchase.shop_id }),
                    credentials: 'same-origin',
                })
                const res = await req.json()
        
                console.log("getShopLocal", {res});
                if(res.error){
                    console.log("getShopLocal", res.error.error);
                } else {
                    if (res.id != "") {
                        setLocal(res)
                    }  
                }
            } catch (error) {
                console.error('Error fetching local details:', error);
            }
        };
        fetchTransferData();
        fetchLocal();
    }, [dispatch, props.purchase.id]);

    const createProductList = () => {

        return purchase.products && purchase.products.map(purchaseItem => {
            const prod = PRODUCTS && PRODUCTS[purchaseItem.product_id]
            const PU = parseFloat(purchaseItem.total_ht) / parseFloat(purchaseItem.quantity)
            const taxU = PU * parseFloat(purchase.surcout)
            const PTTC = purchaseItem.total_ht * parseFloat(purchase.surcout)
            return (
                <TableRow key={purchaseItem.product_id}>
                    <TableCell className="photo-trsf-single">
                        {prod && prod.photos && prod.photos.length > 0 && prod.photos[0].filename &&
                            <img 
                                id={prod.photos[0].filename} 
                                src={`/stocks/photos/${prod.photos[0].filename}`} 
                                // style={{width:"100px", height:"auto"}}
                            />
                        }
                    </TableCell>
                    <TableCell>{prod?.name || `Product ID: ${purchaseItem.product_id}`}</TableCell>
                    <TableCell>{purchaseItem.quantity}</TableCell>
                    <TableCell><Currency value={PU} /></TableCell>
                    <TableCell><Currency value={taxU} /></TableCell>
                    <TableCell><Currency value={purchaseItem.total_ht} /></TableCell>
                    <TableCell><Currency value={PTTC} /></TableCell>
                    {/* <TableCell className="no-print">
                        {!isEmpty(local) &&
                            <IconButton onClick={() => openLocalMap(purchaseItem.list, prod.name)}>
                                <CollectionsBookmark />
                            </IconButton>
                        }
                    </TableCell> */}
                </TableRow>
            )
        });
    };


    const getTotal = () => {
        let total = 0
        if (purchase.products && Array.isArray(purchase.products)) {
            purchase.products.forEach(purchaseItem => {
                total += parseFloat(purchaseItem.total_ht) || 0
            });
        }
        return <Currency value={total} />
    };

    const getPurchaseFeeValue = (fieldName, fallback = 0) => {
        const value = purchase?.[fieldName]
        if (value === "" || value === null || typeof value === "undefined") {
            return fallback
        }
        const parsed = parseFloat(value)
        return Number.isNaN(parsed) ? fallback : parsed
    }

    const openLocalMap = (pItem, productName) => {
        setOpenLocal(true)
        setProductName(productName)
        setPItem(pItem)
    }
    const closePopUp = () => {
        setOpenLocal(false)
        setProductName("")
        setPItem({})
    }

    return (
        <>
        {!isEmpty(purchase) &&
            <SingleTransferTemplate
                transfer={purchase}
                shop={props.shop}
                purchase
                notif={props.notif}
                handleUpdatePurchase={props.handleUpdatePurchase}
            >
                {/* {openLocal &&
                    <PopUp
                        title={`Rangement ${productName}`}
                        close={closePopUp}
                        appbar
                    >
                        <PreviewLoc
                            {...local}
                            pItem={pItem}
                            productName={productName}
                        />
                    </PopUp>
                } */}
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell>Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>PU HT</TableCell>
                            <TableCell>PU Revient</TableCell>
                            <TableCell>Total HT</TableCell>
                            <TableCell>Coût Revient</TableCell>
                            {/* <TableCell></TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createProductList()}
                        <TableRow>
                                <TableCell colSpan={8}></TableCell>
                                
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>Sous Total HT</TableCell>
                                <TableCell>
                                    {getTotal()}
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>Transport</TableCell>
                                <TableCell>
                                    <Currency value={purchase.transport} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>TVA payée</TableCell>
                                <TableCell>
                                    <Currency value={getPurchaseFeeValue("TVA", 0)} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>AIB/BIC payé</TableCell>
                                <TableCell>
                                    <Currency value={getPurchaseFeeValue("aib", 0)} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>Droit et taxes d'importation</TableCell>
                                <TableCell>
                                    <Currency value={getPurchaseFeeValue("douane", 0)} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>Autres frais ou taxes payés sur l'achat</TableCell>
                                <TableCell>
                                    <Currency value={getPurchaseFeeValue("other_taxes", getPurchaseFeeValue("taxes", 0))} />
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={3}></TableCell>
                                <TableCell colSpan={2}>
                                    <Typography variant="h6">
                                        Coût Revient Total
                                    </Typography>
                                </TableCell>
                                <TableCell className="f-700">
                                    <Typography variant="h6"><b><Currency value={purchase.prix_revient} /></b></Typography>
                                </TableCell>
                                <TableCell className="no-print"/>
                            </TableRow>
                    </TableBody>
                </TableLayout>
            </SingleTransferTemplate>
            
        }
        </>
    );
};

export default SingleTransferPurchase
